module.exports = __webpack_public_path__ + "static/media/BOG-3.787487fd.pdf";